import {Land, UnlistedLand} from '@shareland/shareland-common';
import {FunctionComponent} from 'react';
import {useTranslation} from 'react-i18next';

export const TransLandCityStateText: FunctionComponent<{land: Land | UnlistedLand}> = ({land}) => {
  const {t} = useTranslation('translation');

  return (
    <>
      {t('components.landNameHeader.subtitle', {
        context: land.type === 'NEIGHBORHOOD' ? 'neighborhood' : 'city',
        landCity: land.city,
        landState: land.state,
      })}
    </>
  );
};
